import {
  Box,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
  Drawer,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import HomeIcon from "@mui/icons-material/Home";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import DownloadForOfflineRoundedIcon from "@mui/icons-material/DownloadForOfflineRounded";
import BarChartIcon from "@mui/icons-material/BarChart";
import MenuIcon from "@mui/icons-material/Menu";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";

const menuItems = [
  { id: "home", label: "Home", icon: <HomeIcon />, path: "/" },
  { id: "upload", label: "Upload Data", icon: <UploadFileRoundedIcon />, path: "/upload" },
  { id: "download", label: "Download Report", icon: <DownloadForOfflineRoundedIcon />, path: "/download" },
  { id: "trend", label: "Trend", icon: <BarChartIcon />, path: "/trends" },
];

const MenuBar = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);

  const sidebarContent = (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        width: { xs: 260, md: 280 },
        height: "70vh",
        borderRadius: isMobile ? 0 : "50px",
        borderTop: `3px solid ${theme.palette.secondary.main}`,
        borderBottom: `3px solid ${theme.palette.secondary.main}`,
        overflowY: "auto",
      }}
    >
      <Typography
        sx={{
          mb: 2,
          fontWeight: 800,
          fontSize: "1.4rem",
          textAlign: "center",
          color: theme.palette.primary.main,
        }}
      >
        MENU
      </Typography>

      <Divider sx={{ mb: 2 }} />

      <List>
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path;

          return (
            <ListItemButton
              key={item.id}
              selected={isActive}
              onClick={() => {
                navigate(item.path);
                if (isMobile) setOpen(false);
              }}
              sx={{
                borderRadius: "10px",
                mb: 1,
                backgroundColor: isActive
                  ? "rgba(255,144,22,0.15)"
                  : "transparent",
              }}
            >
              <ListItemIcon
                sx={{
                  color: isActive
                    ? theme.palette.secondary.main
                    : "#555",
                }}
              >
                {item.icon}
              </ListItemIcon>

              <ListItemText
                primary={
                  <Typography fontWeight={600}>
                    {item.label}
                  </Typography>
                }
              />
            </ListItemButton>
          );
        })}
      </List>
    </Paper>
  );

  return (
    <>
      {/* Mobile Hamburger Icon */}
      {isMobile && (
        <IconButton
          onClick={() => setOpen(true)}
          sx={{
            position: "fixed",
            top: 100,
            left: 16,
            zIndex: 2000,
            backgroundColor: "#ffffff",
            boxShadow: 3,
          }}
        >
          <MenuIcon />
        </IconButton>
      )}

      {/* Drawer for Mobile */}
      {isMobile ? (
        <Drawer
          anchor="left"
          open={open}
          onClose={() => setOpen(false)}
          PaperProps={{
            sx: {
              mt: { xs: "56px", sm: "64px" },
              height: "fit-content",
              maxHeight: "50vh",
              backgroundColor: "transparent",
              boxShadow: "none",
            },
          }}
        >
          {sidebarContent}
        </Drawer>
      ) : (
        <Box component="aside" sx={{ pt: 10, pl: 2 }}>
          {sidebarContent}
        </Box>
      )}
    </>
  );
};

export default MenuBar;